import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 29,
	height: 28,
	viewBox: "0 0 29 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Icon",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon_2",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23.8335 14.0002C23.8335 19.1548 19.6548 23.3335 14.5002 23.3335C9.3455 23.3335 5.16683 19.1548 5.16683 14.0002C5.16683 8.8455 9.3455 4.66683 14.5002 4.66683C19.6548 4.66683 23.8335 8.8455 23.8335 14.0002ZM26.1668 14.0002C26.1668 20.4435 20.9435 25.6668 14.5002 25.6668C8.05684 25.6668 2.8335 20.4435 2.8335 14.0002C2.8335 7.55684 8.05684 2.3335 14.5002 2.3335C20.9435 2.3335 26.1668 7.55684 26.1668 14.0002ZM13.9168 19.8335C13.5947 19.8335 13.3335 19.5723 13.3335 19.2502V18.0835C13.3335 17.7613 13.5947 17.5002 13.9168 17.5002H15.0835C15.4057 17.5002 15.6668 17.7613 15.6668 18.0835V19.2502C15.6668 19.5723 15.4057 19.8335 15.0835 19.8335H13.9168ZM15.0835 8.16683C15.4057 8.16683 15.6668 8.428 15.6668 8.75016L15.6668 14.5835C15.6668 14.9057 15.4057 15.1668 15.0835 15.1668H13.9168C13.5947 15.1668 13.3335 14.9057 13.3335 14.5835L13.3335 8.75016C13.3335 8.428 13.5947 8.16683 13.9168 8.16683H15.0835Z",
			fill: "#B35F00"
		})
	})]
});
const ForwardRef = forwardRef(SvgAlertCircle);
export { ForwardRef as ReactComponent };
